import { createFileRoute, redirect } from '@tanstack/react-router'

// The shared route registry's REPORTS entry (/reports) is pre-pivot "legacyOps" scaffolding,
// superseded by ADMIN_REPORTS (/admin-reports, the real BillingService ReportsController page)
// — see routes.tsx's comment on ADMIN_REPORTS. It's toggled off in dashboard-sections.json so
// it never appears in the sidebar, but the bare path still 404'd for anyone who hit it directly
// (unlike AI_OPS, also legacyOps, which has a real page). Redirect to the real page instead.
export const Route = createFileRoute('/(admin)/reports/')({
  beforeLoad: () => {
    throw redirect({ to: '/admin-reports' })
  },
})
